import React, { useEffect, useState } from "react";
import MonoButton from "../components/MonoButton";

function BuildCustomCourse() {
  const [projects, setProjects] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    custom_title: "",
    custom_note: "",
    modules: [],
  });

  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/get_all_projects.php")
      .then(res => res.json())
      .then(data => {
        if (data.success) setProjects(data.projects);
      });
  }, []);

  const toggleModule = (project) => {
    const exists = formData.modules.find((m) => m.project_id === project.id);
    if (exists) {
      setFormData((prev) => ({
        ...prev,
        modules: prev.modules.filter((m) => m.project_id !== project.id)
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        modules: [...prev.modules, {
          project_id: project.id,
          start_date: ""
        }]
      }));
    }
  };

  const updateModule = (projectId, value) => {
    setFormData((prev) => ({
      ...prev,
      modules: prev.modules.map((m) =>
        m.project_id === projectId ? { ...m, start_date: value } : m
      ),
    }));
  };

  const handleSubmit = async () => {
    const payload = {
      name: formData.name,
      email: formData.email,
      custom_title: formData.custom_title,
      custom_note: formData.custom_note,
      modules: formData.modules,
    };

const { name, email, modules } = formData;

        if (!name || !email || modules.length === 0) {
        alert("Bitte Name, E-Mail und mindestens ein Modul angeben.");
        return;
        }

const hasMissingDate = modules.some((m) => !m.start_date);
if (hasMissingDate) {
  alert("Bitte wähle für alle gewählten Module ein Startdatum.");
  return;
};

const res = await fetch("https://www.denisbitter.de/stage01/api/save_individual_course.php", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

const raw = await res.text();

let result;
try {
  result = JSON.parse(raw);
} catch (err) {
  console.error("❌ Antwort kein JSON:", raw);
  throw new Error("Ungültige Serverantwort.");
}

if (result.success) {
  alert("✅ Kurs gespeichert");
  setFormData({
    name: "",
    email: "",
    custom_title: "",
    custom_note: "",
    modules: [],
  });
} else {
  alert("❌ Fehler: " + (result.message || "Unbekannt"));
}

  };

  return (
    <div className="p-4 space-y-4 font-mono bg-white border rounded text-sm">
      <h2 className="text-lg font-bold">🧩 Individuellen Kurs zusammenstellen</h2>

      <input
        type="text"
        placeholder="Dein Name"
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        className="border p-2 rounded w-full"
      />
      <input
        type="email"
        placeholder="Deine E-Mail"
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        className="border p-2 rounded w-full"
      />
      <input
        type="text"
        placeholder="Kursname (z.B. 3D Web Basics)"
        value={formData.custom_title}
        onChange={(e) => setFormData({ ...formData, custom_title: e.target.value })}
        className="border p-2 rounded w-full"
      />
      <textarea
        placeholder="Bemerkung (optional)"
        value={formData.custom_note}
        onChange={(e) => setFormData({ ...formData, custom_note: e.target.value })}
        className="border p-2 rounded w-full"
      />

      <div>
        <p className="text-xs text-[#EFEBDC]0">Kursmodule auswählen:</p>
        {projects.map((p) => {
          const isSelected = formData.modules.find((m) => m.project_id === p.id);
          return (
            <div key={p.id} className="border p-3 mb-2 rounded bg-gray-50">
              <label className="flex items-start gap-2">
                <input
                  type="checkbox"
                  checked={!!isSelected}
                  onChange={() => toggleModule(p)}
                />
                <span>
                  <strong>{p.title}</strong> <br />
                  <small>{p.problem}</small> <br />
                  <span className="text-xs text-[#EFEBDC]0">Empfohlene Dauer: {p.durationDays} Tage</span>
                </span>
              </label>

              {isSelected && (
                <div className="mt-2">
                  <label className="block text-xs text-gray-600 mb-1">Startdatum wählen:</label>
                  <input
                    type="date"
                    value={isSelected.start_date}
                    onChange={(e) => updateModule(p.id, e.target.value)}
                    className="border p-1 rounded w-full"
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      <MonoButton onClick={handleSubmit} disabled={!formData.email || !formData.name || formData.modules.length === 0}>
            ➕ Kurs speichern
            </MonoButton>

    </div>
  );
}

export default BuildCustomCourse;
